module.exports = __webpack_public_path__ + "assets/img/travel-day17.34e42cf7.png";